/**
 * @param {string} string - andritz
 * @returns {string} capitalized string = Andritz
 */

export function capitalizeFirstLetter(string: string): string {
  return string[0].toUpperCase() + string.slice(1);
}

export function truncate(str: string, n: number, escape = true): string {
  if (escape) return str.length > n ? `${str.slice(0, n - 1)}&hellip;` : str;
  return str.length > n ? `${str.slice(0, n - 1)}...` : str;
}

export const getChangedTimeText = (changedCount: number) => {
  if (changedCount === 1) {
    return 'once';
  }
  if (changedCount === 2) {
    return 'twice';
  }
  return `${changedCount} times`;
};

export const slugify = (text: string) => {
  return text
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
};

type SolutionUrlProduct = {
  idProduct: number;
  product: string;
  group: { productGroup: string };
  industries: { industry: string }[];
};

type IndustryUrlProduct = {
  idIndustry: number;
  industry: string;
};

type ProductGroupUrlProduct = {
  idProductGroup: number;
  productGroup: string;
};

export function buildSolutionUrl(product: SolutionUrlProduct): string {
  const name = slugify(product.product);
  const group = slugify(product.group.productGroup);
  const industry = product.industries
    .map((i) => slugify(i.industry))
    .sort()
    .join('-');
  if (industry === '') {
    return `/solutions/${product.idProduct}/${group}/generic/${name}`;
  }

  return `/solutions/${product.idProduct}/${group}/${industry}/${name}`;
}

export function buildIndustryUrl(industry: IndustryUrlProduct): string {
  const industryName = slugify(industry.industry);

  return `/industries/${industry.idIndustry}/${industryName}`;
}

export function buildProductGroupUrl(productGroup: ProductGroupUrlProduct): string {
  const productGroupName = slugify(productGroup.productGroup);

  return `/product-groups/${productGroup.idProductGroup}/${productGroupName}`;
}
export function isSolutionUrlParamsCorrect(
  product: SolutionUrlProduct,
  params: { productGroup?: string; industry?: string; solutionName?: string },
): boolean {
  const { productGroup, industry, solutionName } = params;
  return (
    (productGroup === undefined || productGroup === slugify(product.group.productGroup)) &&
    (industry === undefined ||
      industry === 'generic' ||
      industry ===
        product.industries
          .map((i) => slugify(i.industry))
          .sort()
          .join('-')) &&
    (solutionName === undefined || solutionName === slugify(product.product))
  );
}
